var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag"},[_c('small',[_vm._v(_vm._s(_vm.title))]),_c('button',{staticClass:"btn p-0 text-white",on:{"click":function($event){return _vm.$emit('click', _vm.title)}}},[_c('i',{staticClass:"icon-x"})])])}
var staticRenderFns = []

export { render, staticRenderFns }